export default __webpack_public_path__ + "static/media/shop5.20b3dcba.jpg";